<section class="rounded-lg bg-primary-50 p-6">
  <div class="text-center">
    <h3 class="mb-4 text-xl font-semibold text-greyscale-900">
      {{ "impactReport.contribution.title" | transloco }}
    </h3>

    <div
      class="mx-auto mb-6 flex max-w-2xl flex-col gap-3 text-sm text-greyscale-600"
    >
      <p>{{ "impactReport.contribution.descriptionReduction" | transloco }}</p>
      <p>
        {{ "impactReport.contribution.descriptionContribution" | transloco }}
      </p>
    </div>

    <div class="flex justify-center">
      <button
        class="flex items-center gap-2 rounded-lg bg-[#527A6D] px-6 py-2 font-medium text-white transition-colors"
        [class.hover:bg-[#3f6356]]="isSuperAdmin()"
        [class.opacity-50]="!isSuperAdmin()"
        [class.cursor-not-allowed]="!isSuperAdmin()"
        [disabled]="!isSuperAdmin()"
        [pTooltip]="!isSuperAdmin() ? ('pages.comingSoon' | transloco) : ''"
        tooltipPosition="top"
        (click)="onDiscoverProjects()"
      >
        <app-greentripper-pin-icon styleClass="h-5 w-5" />
        {{ "impactReport.contribution.button" | transloco }}
      </button>
    </div>
  </div>
</section>
